import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { E as getStructuredReviewData, g as getLocale, l as transDialog } from './utils2.js';
import { E as EMOJI_POS_VALUE, b as EMOJI_NEG_VALUE } from './const.js';
import { d as defineCustomElement$2 } from './mapy-review-structured-review-item2.js';
import { d as defineCustomElement$1 } from './mapy-review-tooltip2.js';

const mapyReviewStructuredReviewCss = ":host{display:block}.mapy-review-structured-review{display:flex;gap:20px;flex-direction:column;font-family:Arial, Helvetica, sans-serif}.items{display:flex;flex-direction:column;gap:12px}.tooltip-line{display:flex;flex-direction:row}.tooltip-content{display:flex;gap:5px;flex-direction:row;align-items:center;position:relative;flex:0 1 auto}.tooltip-content svg{width:16px;height:16px;fill:#828282}.tooltip-title{color:#828282;line-height:20px;font-size:12px}.tooltip-items{padding:0 15px;margin:0;display:flex;flex-direction:column;gap:8px}.tooltip-item{list-style:disc;flex:auto}.tooltip-item-content{font-size:14px;line-height:16px;display:block}.tooltip-item-content2{font-size:14px;line-height:14px;white-space:pre;overflow:hidden;text-overflow:ellipsis;display:block}mapy-review-tooltip{z-index:10}";
const MapyReviewStructuredReviewStyle0 = mapyReviewStructuredReviewCss;

const MapyReviewStructuredReview = /*@__PURE__*/ proxyCustomElement(class MapyReviewStructuredReview extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.change = createEvent(this, "change", 1);
        this.selectItem = (event) => {
            const value = event.detail.checked
                ? event.detail.type === "positive"
                    ? EMOJI_POS_VALUE
                    : EMOJI_NEG_VALUE
                : null;
            const newItems = this.data.slice();
            newItems.filter(item => item.key === event.detail.key)[0].value = value;
            this.data = newItems;
            this.change.emit({
                items: this.data,
            });
        };
        this.items = [];
        this.tooltip = true;
        this.data = [];
    }
    getValue(item, testValue) {
        const value = this.data.filter(dataItem => dataItem.key === item.key)[0].value;
        return value === testValue;
    }
    componentWillLoad() {
        this.data = getStructuredReviewData(this.items);
    }
    render() {
        const locale = getLocale(this.hostElement);
        return (h(Host, { key: 'b5517858fbd95b44351fdc3835ee0bf3e3c1d4be' }, h("div", { key: '0bd5730fa531656c37a04d8e5c9e7cb0ffe317d6', class: "mapy-review-structured-review" }, h("div", { key: 'cab58c88b68f036b6561a2baa0ab6d7b851164c7', class: "items" }, this.items.map(item => h("mapy-review-structured-review-item", { name: item.key, title: item.name, positive: this.getValue(item, EMOJI_POS_VALUE), negative: this.getValue(item, EMOJI_NEG_VALUE), onSelect: this.selectItem }))), this.tooltip && h("div", { class: "tooltip-line" }, h("div", { class: "tooltip-content" }, h("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", class: "icon icon-square-info" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.16699 14.1666H10.8337V9.16663H9.16699V14.1666ZM11.2503 7.08329C11.2503 7.77329 10.6903 8.33329 10.0003 8.33329C9.31033 8.33329 8.75033 7.77329 8.75033 7.08329C8.75033 6.39329 9.31033 5.83329 10.0003 5.83329C10.6903 5.83329 11.2503 6.39329 11.2503 7.08329ZM16.2395 14.0191C15.9995 15.1275 15.1278 15.9991 14.0195 16.2391C12.707 16.5225 11.3553 16.6666 10.0003 16.6666C8.64533 16.6666 7.29283 16.5225 5.98116 16.2391C4.87199 15.9991 4.00116 15.1275 3.76116 14.0191C3.47783 12.7075 3.33366 11.355 3.33366 9.99996C3.33366 8.64413 3.47783 7.29246 3.76116 5.98079C4.00116 4.87163 4.87283 3.99996 5.98116 3.76079C7.29283 3.47746 8.64533 3.33329 10.0003 3.33329C11.3562 3.33329 12.7087 3.47746 14.0195 3.76079C15.1278 4.00079 15.9995 4.87246 16.2395 5.98079C16.5228 7.29329 16.667 8.64496 16.667 9.99996C16.667 11.355 16.5228 12.7075 16.2395 14.0191ZM17.8678 5.62829C17.4895 3.87663 16.1237 2.51079 14.372 2.13246C12.9628 1.82663 11.5003 1.66663 10.0003 1.66663C8.50033 1.66663 7.03783 1.82663 5.62949 2.13163C3.87616 2.50996 2.51116 3.87579 2.13199 5.62829C1.82699 7.03663 1.66699 8.49913 1.66699 9.99996C1.66699 11.5 1.82699 12.9625 2.13199 14.3708C2.51116 16.1233 3.87616 17.4891 5.62866 17.8675C7.03783 18.1733 8.50033 18.3333 10.0003 18.3333C11.5003 18.3333 12.9628 18.1733 14.372 17.8675C16.1237 17.4891 17.4895 16.1233 17.8678 14.3708C18.1737 12.9625 18.3337 11.5 18.3337 9.99996C18.3337 8.49996 18.1737 7.03746 17.8678 5.62829Z" })), h("span", { class: "tooltip-title" }, transDialog(locale, "tooltipMoreChoices")), h("mapy-review-tooltip", { position: "auto", width: 320 }, h("ul", { class: "tooltip-items" }, this.items.map(item => h("li", { class: "tooltip-item" }, h("span", { class: "tooltip-item-content" }, item.label))))))))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewStructuredReviewStyle0; }
}, [1, "mapy-review-structured-review", {
        "items": [16],
        "tooltip": [516],
        "data": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-structured-review", "mapy-review-structured-review-item", "mapy-review-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-structured-review":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewStructuredReview);
            }
            break;
        case "mapy-review-structured-review-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewStructuredReview as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-structured-review2.js.map